import { getRoles } from "@testing-library/react";
import { GetIncidentStates } from "./ApiCalls/selectFields/getIncidentStates";
import { GetRols } from "./ApiCalls/selectFields/getRols";


  export async function GetIncidentStatesService() {
    try {
      const states = await GetIncidentStates();
  
      const filteredStates = states.filter((_, index) => index !== 0 && index !== 5);

      const statesData = filteredStates.map((state) => state.name);
  
      return statesData;
    } catch (error) {
      // console.error("Error during login:", error);
      // Manejar el error
      throw error;
    }
  }

  export async function GetRolsService() {
    try {
      const rols = await GetRols();
      const rolsNames = rols.map((rol) => rol.name);
  
      return rolsNames;
    } catch (error) {
      // console.error("Error during login:", error);
      // Manejar el error
      throw error;
    }
  }